import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 18933 19044"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#000;stroke-width:211.043}.fil0{fill:#1c1b17;fill-rule:nonzero}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M1448 14352c-311-517-571-1063-776-1627-204-563-356-1147-451-1745-258-1630-79-3269 480-4765 560-1498 1501-2853 2764-3913l804 961c-1098 920-1913 2094-2397 3388-485 1298-640 2719-416 4133 82 516 214 1023 392 1515 178 490 404 963 673 1411l-1073 642zM9453 106c2344-13 4514 837 6182 2269 1670 1436 2839 3454 3179 5773l-1240 182c-295-2012-1307-3762-2753-5004-1448-1244-3331-1983-5363-1971l-5-1249zM17549 14430c-708 1160-1652 2140-2755 2888-1103 747-2365 1260-3705 1488-788 133-1584 165-2369 99-786-68-1566-235-2321-501l411-1180c650 228 1327 373 2013 431 687 59 1379 31 2060-84 1164-197 2257-642 3210-1287 954-646 1772-1497 2388-2506l1068 652zM9462 3876c1556 0 2967 632 3989 1653l3 3c1021 1023 1653 2433 1653 3989 0 1555-632 2966-1653 3989l-3 2c-1022 1022-2433 1653-3989 1653s-2967-632-3990-1654c-1022-1020-1655-2432-1655-3990 0-1559 633-2971 1653-3992 1025-1021 2436-1653 3992-1653zm3104 2538c-792-793-1890-1284-3104-1284s-2311 491-3104 1284c-794 797-1286 1894-1286 3107 0 1212 492 2310 1286 3104 793 795 1890 1286 3104 1286s2312-491 3104-1283l3-3c793-792 1283-1890 1283-3104s-490-2312-1283-3104l-3-3z"
        className="fill stroke1"
        style={{
          strokeWidth: 211.043,
          fillRule: "nonzero",
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
